import Panel from '../components/panel'
import {Button} from '../components//button'
import PropertyInput from "../components/inputs/input-property.tsx";

import { useStore } from "../state/state.ts";
import { PanelImg } from '../components/img.tsx';
import { ModalClose } from '../components/modal-close.tsx';

export default function ModalInfoVollgeschosse() {
    const pop_modal = useStore((state)=>state.pop_modal);
    
  return (<Panel >
            <h1 id="modal-title">Vollgeschosse</h1>
            <p id="modal-description">Vollgeschosse sind die Geschosse oder auch Etagen im Gebäude, die eine Höhe von mindestens 2,30 m haben. Dazu zählen z. B. das Erdgeschoss, Obergeschosse oder Dachgeschosse. Wohnräume im Keller oder Souterrain nur, wenn deren Deckenoberkante im Mittel mehr als 1,60 m über die Geländeoberfläche hinausragt.</p>
            <ModalClose label={"weiter"} onClick={()=>{
                            pop_modal();
                        }}/>
         </Panel>)
}

